import React, { useEffect } from 'react';
import { Spin } from 'antd';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

const Spinner = ({ loading = false }) => {
  const applicationLoading = useSelector(
    state => state.forms.applicationLoading,
    (prev, next) => prev === next
  ); //den xreiazete na kanei render ka8e fora, mono otan exei allaksei kati sto state

  const shouldDisplay = loading || applicationLoading;

  useEffect(() => {
    if (!shouldDisplay) return;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [shouldDisplay]); //cleanup function gia kalytero unmount, document.body access einai kalytero apo to querySelector

  if (!shouldDisplay) return null; 
  return (
    <div className="custom-spinner">
      <div>
        <Spin size="large" />
      </div>
    </div>
  ); //ebala ena wrapper div gia kalytero positioning control
};

Spinner.propTypes = {
  loading: PropTypes.bool,
 };

export default React.memo(Spinner); //memo gia na apotrepsw rerender and ta prop den exoyn allaksei

